import { render, staticRenderFns } from "./vdownload.vue?vue&type=template&id=de4d62a6&"
import script from "./vdownload.vue?vue&type=script&lang=js&"
export * from "./vdownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports